<div class="modal-header">
  <p *ngIf="title && title.length > 0" class="modal-title">{{ title }}</p>
  <p *ngIf="!title || !(title.length > 0)" class="modal-title" jhiTranslate="entity.action.confirmTitle">Confirm</p>
  <button type="button" class="text-white close" data-dismiss="modal" aria-hidden="true" (click)="clear()">
    <fa-icon [icon]="faTimes"></fa-icon>
  </button>
</div>
<div class="modal-body">
  <p [innerHTML]="message"></p>
</div>
